export const urlQueries = () => {
  let queries = {};
  try {
    let search = window.location.search.match(/\?.*(?=\b|#)/);
    if (search) {
      search = search[0].replace(/^\?/, "");
    }
    if (search) {
      search.split('&').forEach((item) => {
        const param = item.split('=');
        if (param[1]) {
          queries[param[0]] = decodeURIComponent(param[1])
        }
      });
    }
    if (typeof window?.ssrConfig?.routerConfig?.short?.params === 'object' && !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)) {
      queries = Object.assign({}, queries, window.ssrConfig.routerConfig.short.params);
    }
    return queries;
  } catch (err) {
    console.log("整理参数失败: ", err);
    return {};
  }
};

export const coverQuery = (route) => {
  const queries = urlQueries()
  if (route && route.query) {
    Object.keys(queries).forEach(key => {
      if (!route.query[key]) {
        // 不存在的情况下才覆盖
        route.query[key] = queries[key]
      }
    })
  }
}

/**
 * 判断是否是游戏频道的链接
 * @param { 跳转链接 } url
 * @returns
 */
export const isGamePage = (url) => url && url.indexOf('://game') !== -1 && !!(url.indexOf('wownow.net') !== -1 || url.indexOf('lifekh.com') !== -1);
/**
 * 封装的 timeout
 * @param {*} callback
 * @param {*} timestamp
 * @returns
 */
export const currentTimeout = (callback, timestamp = 0) => (window?.$vm?.$root?.timeout?.(callback, timestamp) || (() => {
  const timeout = setTimeout(() => {
    clearTimeout(timeout);
    typeof callback === 'function' && callback();
  }, timestamp);
  return timeout;
}))
//  统一跳转函数
export const goPage = (url, callback) => {
  //  先判断是否是游戏频道的链接
  const isGameUrl = isGamePage(url);
  //  如果是 vue-router 内的路由，则进行页面内跳转
  if (!isGameUrl && window?.$vm?.$router?.options?.routes?.length) {
    for (const e of window.$vm.$router.options.routes) {
      if (e.path && url.indexOf(process.env.NODE_ENV === 'development' && e.path.replace(/\/index/g, '') || e.path) !== -1) {
        return window.$vm.$router.push({
          path: e.path + (url.indexOf('?') !== -1 && `?${url.split('?')[1]}` || '')
        });
      }
    }
  }
  if (window?.$vm?.$root?.setBackPopstate) {
    const __currentDocumentTitle = document.title;
    window.$vm.$root.setBackPopstate(() => {
      currentTimeout(() => {
        try {
          callback();
        } catch (err) {}
        window?.$vm?.$router?.go?.(-1);
        window?.WOWNOW?.setNavigationBarStyle?.({
          style: 0
        });
        navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1 && window?.WOWNOW?.allowsBackForwardNavigationGestures?.({ value: true });

        document.title = __currentDocumentTitle;
        if (navigator.userAgent.toLowerCase().indexOf('wownow') !== -1 && window?.$vm?.$root && window?.WOWNOW?.setNavigationBarTitle) {
          window.$vm.$root.currentDocumentTitle = __currentDocumentTitle;
          window.WOWNOW.setNavigationBarTitle({
            title: __currentDocumentTitle
          });
        }
      }, 500);
    });
  }
  window.location.href = url;
};
/**
* https://game-fat.lifekh.com/match-home   uat
* https://game-sit.lifekh.com/match-home    sit
* https://game.wownow.net/match-home     生产
*/
export const gameHost = {
  pro: 'https://game.wownow.net',
  uat: 'https://game-fat.lifekh.com',
  sit: 'https://game-sit.lifekh.com'
};
/**
 * 获取当前环境的游戏频道域名
 */
export const getGameCurrentHost = () => gameHost[window?.ssrConfig?.routerConfig?.env ?? (process.env.NODE_ENV === 'development' && 'sit' || (window.location.host.indexOf('h5-') !== -1 && window.location.host.split('.')[0].split('-')[1] || 'pro'))];

export const parseURLWH = (url) => {
  // https://tinhnow.oss-ap-southeast-1.aliyuncs.com/wownow/files/sit/app/M89/89/50/4E/f5b22890e15b11ecb12d8b8277a9be4c.png?WxH=199x199
  // https://tinhnow.oss-ap-southeast-1.aliyuncs.com/wownow/files/sit/app/M89/89/50/4E/406b6420947f11ec8c7b1d34ab029932.png?w=600&h=420
  if (!url) {
    throw new Error('can\'t not resolve a empty url!')
  }
  const result = { radio: 1 }
  if (url.indexOf('?') === -1) {
    return result
  }
  url = url.toLocaleLowerCase()
  const queries = url.split('?')[1].split('&')
  for (let i = 0; i < queries.length; i++) {
    const item = queries[i]
    const [key, value] = item.split('=')
    if (key === 'wxh') {
      result.width = Number(value.split('x')[0])
      result.height = Number(value.split('x')[1])
    }
    if (key === 'w') {
      result.width = Number(value)
    }
    if (key === 'h') {
      result.height = Number(value)
    }
  }
  if (result.width && result.height) {
    result.radio = Number((result.width / result.height).toFixed(2))
  }
  return result
}

/**
* https://www.wownowtravel.com  生产
* https://hotel-uat.lifekh.com  uat
* https://hotel-sit.lifekh.com  sit
*/
export const hotelHost = {
  pro: 'https://www.wownowtravel.com',
  uat: 'https://hotel-uat.lifekh.com',
  sit: 'https://hotel-sit.lifekh.com'
};
/**
 * 获取当前环境的游戏频道域名
 */
export const getHotelCurrentHost = () => hotelHost[window?.ssrConfig?.routerConfig?.env ?? (process.env.NODE_ENV === 'development' && 'sit' || (window.location.host.indexOf('h5-') !== -1 && window.location.host.split('.')[0].split('-')[1] || 'pro'))];
